export enum CharmPickerBackground {
    Light = 1,
    CalendarColor,
}

export default CharmPickerBackground;
